module.exports = __webpack_public_path__ + "c382d8224bdd1e2f605a1663ed8f7a5c.png";